import BaseExecutor from './base-executor';
import Action from 'actions';
import {getSimplexKeyUnitName} from 'helpers/simplex-helper';
import KeyPlayerStackMarker from 'services/key-player-stacking/key-player-stack-marker';

export class Settings extends BaseExecutor {
    saveCorrelationStackingSettings({incomingValues: {dispatch}}) {
        const {correlationStacking} = Action.getState();

        if (!correlationStacking.settings.isEnabled()) {
            return;
        }

        const stacks = correlationStacking.settings.getItems();
        const settingsKey = correlationStacking.settings.getStateId();
        const settings = {};

        stacks.forEach((stackItem) => {
            settings[stackItem.getId()] = {
                keyPlayerId: stackItem.getKeyPlayerId(),
                isGameStack: stackItem.isGameStackType(),
            };
        });

        dispatch(Action.set('RunSettings', settingsKey, settings));
    }

    saveKeyPlayerStackingGroups({incomingValues: {dispatch}}) {
        const {
            stacks: {groups},
        } = Action.getState();

        if (!groups.hasItems()) {
            return;
        }

        const items = groups.all();
        const settingsKey = groups.getStateId();
        const settings = {};

        items.forEach((item) => {
            const [keyPlayerId] = item.keys;
            const simplexUnitId = KeyPlayerStackMarker.setSuffix(
                getSimplexKeyUnitName([item.stackItemId, keyPlayerId]),
            );
            settings[simplexUnitId] = {...item};
        });

        dispatch(Action.set('RunSettings', settingsKey, settings));
    }

    saveNonControlledHitterStackingSettings({incomingValues: {dispatch}}) {
        const {
            nonControlledHitterStacking: {settings: stacking},
        } = Action.getState();
        const stacks = stacking.getStacks();

        const settingsKey = stacking.getStateId();
        const settings = {
            enabled: stacking.isEnabled(),
            stacks: {},
            isEnabled() {
                return this.enabled;
            },
            getPlayersQuantityByStackNumber(stackNumber) {
                return this.stacks[stackNumber].playersQuantity;
            },
        };
        Object.keys(stacks).map((stackNumber) => {
            settings.stacks[stackNumber] = {
                playersQuantity: stacks[stackNumber].playersQuantity,
            };
        });

        dispatch(Action.set('RunSettings', settingsKey, settings));
    }
}
